const headerHeight = 3;

export default () => ({
    height: '100%',
    '> h2': {
        display: 'flex',
        justifyContent: 'space-between',
        height: `${headerHeight}rem`,
        margin: '0',
    },
    '> div': {
        overflowX: 'auto',
        height: `calc(100% - ${headerHeight}rem)`,
    },
});
